import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStepperArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.683 6.831 C 9.494 6.919,4.389 12.035,4.318 12.207 C 4.206 12.477,4.282 12.847,4.487 13.040 C 4.688 13.228,5.034 13.289,5.293 13.182 C 5.379 13.146,6.107 12.441,7.708 10.841 L 10.000 8.550 12.292 10.841 C 13.893 12.441,14.621 13.146,14.707 13.182 C 14.966 13.289,15.312 13.228,15.513 13.040 C 15.718 12.847,15.794 12.477,15.682 12.207 C 15.611 12.035,10.506 6.919,10.317 6.831 C 10.237 6.793,10.110 6.768,10.000 6.768 C 9.890 6.768,9.763 6.793,9.683 6.831 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgStepperArrow;
